import React from 'react';
import styled from '@emotion/styled';
import {
  Heading,
  Text,
} from '@ayble-health/dashboard-components';
import { Button } from 'components/ui/button';
import { useNavigate } from 'react-router-dom';
import type { EmotionTheme } from '../../theme/emotionTheme';

const PageWrapper = styled('div')<{ theme?: EmotionTheme }>`
  align-items: center;
  background-color: ${(p) => p.theme.colors.muted['50']};
  display: flex;
  flex-direction: column;
  height: 100vh;
  text-align: center;
`;

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <Heading size={'4xl'} fontWeight={'bold'} pt={20}>
        404
      </Heading>

      <Text fontSize={'4xl'} fontWeight={'normal'} pb={6}>
        Oops! Page Not Found.
      </Text>

      <Button
        onClick={() => {
          navigate('/');
        }}
      >
        Go back to Home
      </Button>
    </PageWrapper>
  );
};
